import { SVGProps } from 'react';

function RedCancel(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M11 20.374a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75Z"
        stroke="#E72369"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m7.25 14.749 7.5-7.5M14.75 14.749l-7.5-7.5"
        stroke="#E72369"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

RedCancel.defaultProps = {
  role: 'graphics-document',
};

export default RedCancel;
